import React from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function StaffDetails({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="secTitle">
          <h5>
            1. Proper display/availability of IEC material at the NACP
            facilities (Yes/No): (mention observations in the remarks column)
          </h5>
        </div>

        <div className="row">
          <div className="col-lg-2">
            <div className="form-group">
              <label>Select Constituted</label>
              <div className="mb-3 d-flex gap-3 mt-3">
                <Form.Check
                  inline
                  type="radio"
                  id="yes"
                  name="status"
                  label="Yes"
                  className="custom-radio "
                />
                <Form.Check
                  inline
                  type="radio"
                  id="no"
                  name="status"
                  label="No"
                  className="custom-radio"
                />
              </div>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 2 */}
        <div className="secTitle">
          <h5>
            2. Did the DISHA receive feedback on the last month DMMR from SACS
            (Yes/No): (On the data quality, and major performance
            indicators/achivements etc., write in details)
          </h5>
        </div>

        <div className="row">
          <div className="col-lg-2">
            <div className="form-group">
              <label>Select Constituted</label>
              <div className="mb-3 d-flex gap-3 mt-3">
                <Form.Check
                  inline
                  type="radio"
                  id="yes"
                  name="Constituted"
                  label="Yes"
                  className="custom-radio"
                />
                <Form.Check
                  inline
                  type="radio"
                  id="no"
                  name="Constituted"
                  label="No"
                  className="custom-radio"
                />
              </div>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 3  */}
        <div className="secTitle">
          <h5>
            3. Mention the comments/suggetions of SACS/NACO officials visits to
            the DISHA Unit/Cluster, if any (Name and designation, and dates
            (dd/mm/yyyy):{" "}
          </h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 4 */}
        <div className="secTitle">
          <h5>
            4. Mention the action taken as per the last DISHA review meeting
            conducted by SACS and attended by DISHA Unit/Cluster (mention the
            date dd/mm/yyyy):{" "}
          </h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <input type="text" placeholder="Enter Date" />
            </div>
          </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
